import { useCallback, useState } from 'react';

function useDebounce(callback, delay) {
  const [timeoutId, setTimeoutId] = useState(null);

  const debouncedFunction = useCallback((...args) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    const newTimeoutId:any = setTimeout(() => {
      callback(...args);
    }, delay);
    setTimeoutId(newTimeoutId);
  }, [callback, delay, timeoutId]);

  return debouncedFunction;
}

export default useDebounce;
